export const nonAuth = [
  '/',
  '/registration',
  '/registration-review',
  '/registration-setup',
  '/make-password/[id]',
  '/inquiry',
];
